export const CustomEvents = {
  AJAX_EVENTS: {
    loaded:'ajax:loaded',
    updated:'ajax:updated'
  },
  LOADER_EVENTS: {
    show: 'loader:show',
    hide: 'loader:hide',
    showLocal: 'loader:showlocal',
    hideLocal: 'loader:hidelocal',
    visible: 'loader:visible',
    hidden: 'loader:hidden'
  },
  LOAD_COMPONENT: {
    simplebar: 'load:simplebar',
  },
  KEYBOARD_EVENTS: {
    escape: 'ku:key:escape',
    enter: 'ku:key:enter',
    tab: 'ku:key:tab',
  },
  MQ_EVENTS: {
    xs: {
      in: 'mq.xs.in',
      out: 'mq.xs.out',
      current: 'mq.xs.cur'
    },
    sm: {
      in: 'mq.sm.in',
      out: 'mq.sm.out',
      current: 'mq.sm.cur'
    },
    md: {
      in: 'mq.md.in',
      out: 'mq.md.out',
      current: 'mq.md.cur'
    },
    lg: {
      in: 'mq.lg.in',
      out: 'mq.lg.out',
      current: 'mq.lg.cur'
    },
    xl: {
      in: 'mq.xl.in',
      out: 'mq.xl.out',
      current: 'mq.xl.cur'
    }
  },
  SEARCH_LAYER_EVENTS: {
    open: 'search.layer:open',
    close: 'search.layer:closed',
  },
  BACKDROP_EVENTS: {
    show: 'backdrop:show',
    hide: 'backdrop:hide',
    hidden: 'backdrop:hidden',
    shown: 'backdrop:shown'
  },
  PRODUCT_EVENTS: {
    addtocart: 'product:addtocart',
    giftcardaddtocart: 'product:giftcardaddtocart',
    sizerequired: 'product:sizerequired',
    sizechanged: 'product:sizechanged',
    notifyme: 'product:notifyme',
    notifymeclose: 'product:notifymeclose',
    notifymeended: 'product:notifymeended',
    addtowish: 'product:addtowish',
    addedtowish: 'product:addetowish',
    removefromwish: 'product:removefromwish',
    removedfromwish: 'product:removedfromwish',
    editorialcontentloaded: 'product:editorialcontentloaded'
  },
  SIZES_EVENTS: {
    sizesopen: 'sizes:open',
    sizesclose: 'sizes:close',
    sizestoggle: 'sizes:toggle',
  },
  MINICART_EVENTS: {
    open: 'minicart:open',
    updateqty: 'minicart:updateqty',
    update: 'minicart:update'
  },
  MODAL_EVENTS: {
    show: 'modal_ev:show',
    hide: 'modal_ev:hide',
    shown: 'modal_ev:shown',
    hidden: 'modal_ev:hidden',
    afterOpen: 'modal_ev:afterOpen',
    afterClose: 'modal_ev:afterClose',
    egonValidation: 'modal_ev:egonValidation'
  },
  SORT_BY_EVENTS: {
    changed: 'sortBy:changed',
  },
  FILTERS_EVENTS: {
    updated: 'query:updated',
    pageLoaded: 'ajaxPage:loaded',
    currentPriceRangeInput: 'currentPriceRangeInput',
    launchQuery: 'filtersQuery:launch',
  },
  PAGE_LAYOUT_EVENTS: {
    changed: 'pageLayout'
  },
  INFINITE_SCROLL_EVENTS: {
    next: 'infiniteScroll:next',
    loaded: 'infiniteScroll:loaded',
    animation: 'infiniteScroll:animation'
  },
  COOKIE: {
    accepted: 'cookie:accepted'
  },
  RETURN_EVENTS: {
    subsituteProduct: 'product:substituted'
  },
  CAROUSEL: {
    triggerCarousel: 'carousel:trigger'
  },
  MENU_EVENTS: {
    showMenu: 'menu:show',
    hideMenu: 'menu:hide'
  },
  CHECKOUT_EVENTS: {
    showInvoiceForm: 'invoice:show',
    showInvoiceFormLabels: 'invoiceLabels:show',
    hideInvoiceForm: 'invoice:hide',
    showShippingForm: 'shipping:show',
    hideShippingForm: 'shipping:hide',
    paymentSelected: 'payment:selected',
    privacyChange: 'privacy:change',
  },
  SHIPMENT_EVENTS: {
    valid: 'checkout:proceed',
    invalid: 'checkout:stop',
  },
  PAYMENTS_EVENTS: {
    paypal: 'paypal:token'
  },
  CHANGE_AVAILABLE_LAYER:{
    available: 'availableChange:true'
  },
  CHANGE_RETURN_STEPS:{
    enableConfirm:'confirmBtn:enabled',
    disabledConfirm: 'confirmBtn:disabled',
  },
  SIZE_GUIDE:{
    toggle: 'sizeGuide:toggle',
  },
  NOTIFY_ME_STATE:{
    sent: 'notifyme:sent',
  },
  TRACKING:{
    loadMore: 'track:loadMore',
  },
  O2O:{
    ccManualSearch: "StoreLocator:Search:Place",
    ccStoreSelect: "StoreLocator:Store:Select",
    ccStoresShowResults: "StoreLocator:Stores:ShowResults",
  },
  VALIDATION:{
    bindValidation: "validation:bind",
  },
  PDP_LAYER_EVENTS: {
    open: 'pdpLayer:open',
    close: 'pdpLayer:close',
  },
  MODAL: {
    hide: 'modal:hide',
    show: 'modal:show',
  },
  NEWSLETTER: {
    subscribed: 'newsletter:subsribed',
  },
  COM_POPUP: {
    hide: 'comPop:hide',
  },
  FIDELITY_POPUP: {
    hide: 'fidPop:hide',
  },
  COLLAPSE_EVENTS:{
    update: "collapse:update",
  },
  ACCORDION: {
    collapse: 'accordion:collapse',
    expand: 'accordion:expand',
  },
  ACCOUNT_EVENTS: {
    pwdResetForm: 'resetForm:show',
  },
  SIMPLE_CAROUSEL: {
    init: 'simpleCarousel:init',
    beforeChange: 'simpleCarousel:beforeChange',
  },
  PRICE_RANGE_FILTER: {
    reset: 'priceRangeFilter:reset',
    disable: 'priceRangeFilter:disable',
    enable: 'priceRangeFilter:enable',
  },
};
